import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingStateProps {
  size?: number;
  message?: string | string[];
  fullPage?: boolean;
  minHeight?: number | string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  size = 60,
  message,
  fullPage = false,
  minHeight,
}) => {
  const messages = Array.isArray(message) ? message : message ? [message] : [];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        ...(fullPage && {
          minHeight: minHeight || '100vh',
          height: '100%',
        }),
        ...(minHeight && !fullPage && { minHeight }),
        ...(fullPage && { py: 4 }),
      }}
    >
      <CircularProgress size={size} />
      {messages.length > 0 && (
        <Box sx={{ textAlign: 'center' }}>
          {messages.map((msg, index) => (
            <Typography
              key={index}
              variant={index === 0 ? 'h6' : 'body2'}
              color="text.secondary"
            >
              {msg}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
};
